import script from "./globalHeaderNavigationTray.vue?vue&type=script&lang=js"
export * from "./globalHeaderNavigationTray.vue?vue&type=script&lang=js"

import "./globalHeaderNavigationTray.vue?vue&type=style&index=0&id=5690fdd0&lang=scss"

const __exports__ = script;

export default __exports__